import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const STATUSES = ["new", "reviewing", "quoted", "won", "lost"];

export default function QuoteInbox() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/quote_requests").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (it, status) => {
    try { await api.put(`/admin/quote_requests/${it.id}`, { ...it, status }); toast.success("Status updated"); load(); }
    catch { toast.error("Failed"); }
  };
  const remove = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/quote_requests/${id}`); load(); };

  return (
    <div>
      <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-2">// Quote Requests</div>
      <h1 className="font-display font-black text-4xl text-white uppercase mb-8">Freight Quote Inbox</h1>

      <div className="space-y-4">
        {items.length === 0 && <div className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6 text-slate-500 text-sm">No quote requests yet.</div>}
        {items.map((it) => (
          <div key={it.id} className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-6" data-testid={`quote-${it.id}`}>
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-head uppercase tracking-widest text-white">{it.contact_name}</span>
                  <span className="text-xs font-mono-lt text-slate-500">{it.company}</span>
                </div>
                <div className="text-slate-300 mt-1 text-sm">{it.origin} → {it.destination} · {it.equipment_type} · {it.weight_lbs} lbs</div>
                <div className="text-xs text-slate-500 mt-1">{it.contact_email} · {it.contact_phone}{it.pickup_date ? ` · pickup ${it.pickup_date}` : ""}</div>
                {it.commodity && <div className="text-xs text-slate-500 mt-1">Commodity: {it.commodity}</div>}
                {it.notes && <div className="mt-2 text-sm text-slate-400 border-l-2 border-[var(--lt-accent)] pl-3">{it.notes}</div>}
              </div>
              <div className="flex items-center gap-2">
                <Select value={it.status} onValueChange={(v) => setStatus(it, v)}>
                  <SelectTrigger className="w-32 bg-[var(--lt-bg)] border-[var(--lt-border)] text-white h-9 rounded-xl text-xs uppercase tracking-widest"><SelectValue /></SelectTrigger>
                  <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
                <Button size="sm" variant="ghost" onClick={() => remove(it.id)} className="text-slate-500 hover:text-red-400 rounded-xl">Delete</Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
